<template>
  <div class="call_log">
    <a-spin :spinning="loading">
      <div class="header z-flex" v-if="props.showOption">
        <div>
          <a-radio-group v-model:value="queryParam.queryType" button-style="solid">
            <a-radio-button :value="1">近七天</a-radio-button>
            <a-radio-button :value="2">近1月</a-radio-button>
            <a-radio-button :value="3">全部</a-radio-button>
          </a-radio-group>
          <a-checkbox class="currentOrder" v-model:checked="queryParam.isCurrentWorkOrder">
            只看当前工单的沟通记录
          </a-checkbox>
        </div>
        <div>
          <a-select v-model:value="queryParam.endStatus" style="width: 224px">
            <a-select-option :value="item.val" v-for="item in statusOptions" :key="item.val">
              {{ item.lable }}
            </a-select-option>
          </a-select>
        </div>
      </div>
      <div class="table">
        <a-table
          :dataSource="tableData"
          :columns="columns"
          :pagination="false"
          :rowKey="(record, index) => index"
        >
          <!-- 呼出人， callerType主叫方类型：1患者、2医生、3bd、4医生助手-->
          <template #callerType="{ record }">
            <div class="service_person">
              <roles :solerType="record.callerType" />
              <span>{{ record.callerName }}</span>
              <auth-img :src="callIcon" />
            </div>
          </template>
          <!-- 接听人 callerType主叫方类型：1患者、2医生、3bd、4医生助手-->
          <template #calleeName="{ record }">
            <div class="service_person">
              <roles :solerType="record.calleeType" />
              <span>{{ record.calleeName }}</span>
            </div>
          </template>
          <!-- 电话时长 -->
          <template #duration="{ record, index }">
            <template v-if="record.duration">
              <div @click="play(index)" class="call_duration" v-if="!record.isPlay">
                <auth-img :src="playIcon" />
                <span>{{ renderTime(record.duration) }}</span>
              </div>
              <div v-if="record.isPlay">
                <audio :src="record.audioUrl" controls ref="audioRef"></audio>
              </div>
            </template>
            <template v-else>--</template>
          </template>
          <!-- 通话状态 -->
          <template #endStatusDesc="{ record }">
            <span :class="{ red: record.errorStatusFlag }">
              {{ record.endStatusDesc || '--' }}
            </span>
          </template>
          <!-- 关联工单-->
          <template #action="{ record }">
            <div v-if="showWorkOrderBtn(record)">
              <a
                v-for="(item, index) in record?.relatedTickets"
                @click="getWorkOrder(item.workOrderId)"
                :key="item"
              >
                {{ item.workOrderId }}
                <span v-if="index !== record?.workOrderIds?.length - 1">、</span>
              </a>
            </div>
            <span v-else>--</span>
          </template>
          <!-- 操作 -->
          <template #operate="{ record }">
            <div v-if="record.buttonDisplay || record.readSummaryCheck">
              <a :style="{ marginRight: '10px' }" @click="openFullText(record)">通话全文</a>
              <!-- 只有本人可以编辑 编辑提交后全员可看 -->
              <a v-if="record.readSummaryCheck" @click="handleSummary(record)">查看小结</a>
              <!-- ai生成失败 -->
              <template v-if="record.chatSummaryStatus === 0">
                <a v-if="record.chatSummaryRetryCount < 2" @click="onCreateSummary(record)">
                  AI重新生成小结
                </a>
                <a v-else v-show="record.writeSummaryCheck" @click="handleSummary(record)">
                  填写小结
                </a>
              </template>
            </div>
            <span v-else>--</span>
          </template>
        </a-table>
      </div>
      <div class="pagination" v-if="!cdrIds.length">
        <a-pagination
          show-size-changer
          v-model:current="pagination.current"
          v-model:pageSize="pagination.pageSize"
          :total="pagination.total"
          @change="onShowSizeChange"
          @showSizeChange="onShowSizeChange"
          :show-total="total => `总共 ${pagination.total} 条`"
        />
      </div>
    </a-spin>
    <PatientInfoDetails
      :showAllDialog="showAllDialog"
      :currentInfo="currentInfo"
      @handleCancel="handleCancel"
    />
    <a-modal
      title="沟通小结"
      :visible="summaryPanelVisible"
      @cancel="summaryPanelVisible = false"
      width="1059px"
      :footer="null"
      :destroyOnClose="true"
      :maskClosable="false"
      :bodyStyle="{
        padding: 0,
        paddingTop: '20px'
      }"
    >
      <summaryPannel
        :chatSummaryId="chatSummaryId"
        @closeSummaryModal="summaryPanelVisible = false"
        :origin="origin"
      />
    </a-modal>
    <EditSummary ref="editSummaryRef" @changeTab="getData" />
    <FullText ref="FullTextRef" />
  </div>
</template>
<script setup>
import FullText from '@/components/FullText/index.vue'
import { columns, paginationConfig } from './config'
import {
  reactive,
  ref,
  onMounted,
  nextTick,
  computed,
  watch,
  defineProps,
  defineEmits,
  createVNode
} from 'vue'
import { useStore } from 'vuex'
import playIcon from '@/assets/img/chat/playIcon.png'
import callIcon from '@/assets/img/chat/callIcon.png'
import PatientInfoDetails from '@/components/PatientInfoDetails'
import { getCdrList, getTccEndStatus } from '@/api/chat'
import { workOrderDetail } from '@/api/Todo/index'
import { renderTime, showWorkOrderBtn } from '@/utils'
import { useRouter } from 'vue-router'
import { useSummary } from '@/hooks/useSummary'
import EditSummary from '@/views/WorkPlace/Container/Summary/editSummary.vue'
import summaryPannel from '@/views/WorkPlace/Container/chat/components/summaryPannel/index.vue'

const groupInfo = computed(() => store.state.workOrder.workOrderGroupInfo)
const dealWorkOrderList = computed(() => groupInfo.value?.dealWorkOrderList || [])
const emits = defineEmits(['closeSummaryModal'])
const router = useRouter()
const props = defineProps({
  cdrId: {
    type: Number,
    default: null
  },
  cdrIdArr: {
    type: Array,
    default: () => []
  },
  ucUserId: {
    type: Number,
    default: null
  },
  ucDoctorId: {
    type: Number,
    default: null
  },
  mode: {
    type: String,
    default: ''
  },
  showOption: {
    type: Boolean,
    default: true
  },
  workOrderId: {
    type: String,
    default: ''
  }
})
// 兼容批量查询多个通话记录
const cdrIds = computed(() => {
  let id = null
  if (props.cdrIdArr?.length) {
    id = props.cdrIdArr
  } else {
    id = props.cdrId ? [props.cdrId] : []
  }
  return id
})
// 查看关联工单详情
const showAllDialog = ref(false)
const currentInfo = ref({})
const statusOptions = ref([])
const store = useStore()
const queryParam = reactive({
  queryType: 1,
  isCurrentWorkOrder: false,
  endStatus: '',
  ucPatientId: props.mode === 'read' ? props.ucUserId : groupInfo?.value?.patientInfo?.ucUserId,
  ucDoctorId: props.mode === 'read' ? props.ucDoctorId : groupInfo?.value?.doctorInfo?.ucUserId,
  workOrderId: props.mode === 'read' ? props.workOrderId : dealWorkOrderList.value[0]?.workOrderId
})

const tableData = ref([])
const audioRef = ref(null)
const loading = ref(false)
watch(
  () => queryParam,
  () => {
    Object.assign(pagination, paginationConfig)
    getData()
  },
  { deep: true }
)
const pagination = reactive({ ...paginationConfig })
// 改变每页条数
const onShowSizeChange = (page, pageSize) => {
  pagination.pageSize = pageSize
  pagination.current = page
  getData()
}
// 获取数据
function getData() {
  loading.value = true
  const { pageSize, current } = pagination

  const params = {}
  if (cdrIds.value.length) {
    const query = {
      cdrIds: cdrIds.value,
      pageSize,
      pageNo: current
    }
    Object.assign(params, query)
  } else {
    const query = {
      ...queryParam,
      pageSize,
      pageNo: current
    }
    Object.assign(params, query)
  }
  getCdrList(params)
    .then(res => {
      const { list, currPage, totalCount } = res
      pagination.current = currPage
      pagination.total = totalCount
      tableData.value = list
    })
    .catch(() => {
      tableData.value = []
    })
    .finally(() => {
      loading.value = false
    })
}
const { editSummaryRef, chatSummaryId, summaryPanelVisible, handleSummary, onCreateSummary } =
  useSummary(getData)
// 播放录音
function play(index) {
  console.log(index)
  tableData.value.forEach(it => (it.isPlay = false))
  tableData.value[index].isPlay = true
  nextTick(() => {
    audioRef.value.play()
  })
}

//查看关联工单
const getWorkOrder = workOrderId => {
  workOrderDetail({ workOrderId }).then(res => {
    showAllDialog.value = true
    currentInfo.value = res.workOrder
  })
}
// 获取通话记录状态
const getStutusOptions = () => {
  getTccEndStatus().then(res => {
    statusOptions.value = res.map(it => {
      return { lable: it.value, val: it.code }
    })
    statusOptions.value.unshift({
      lable: '全部',
      val: ''
    })
  })
}
const handleCancel = () => {
  showAllDialog.value = false
  currentInfo.value = {}
}
const FullTextRef = ref(null)
const openFullText = record => {
  const { cdrId } = record
  FullTextRef.value.openModal(cdrId)
}

onMounted(() => {
  getData()
  getStutusOptions()
})
</script>
<style scoped lang="scss">
.call_log {
  padding: 20px;
  .red {
    color: #f5222d;
  }
  .header {
    padding: 10px 20px;
    background-color: #ffffff;
    margin-bottom: 20px;
  }
  .currentOrder {
    margin-left: 40px;
  }
  .table {
    .service_person {
      img {
        margin-left: 8px;
        width: 16px;
        height: 16px;
      }
    }
    .call_duration {
      cursor: pointer;
      img {
        width: 16px;
        height: 16px;
        margin-right: 12px;
      }
    }
  }
  .pagination {
    margin-top: 16px;
  }
}
</style>
